import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Segment from './Segment';

export class Segmented extends PureComponent {
  constructor(props) {
    super(props);

    this.segments = [];
    this.focus = this.focus.bind(this);
  }

  focus() {
    if (this.segments && this.segments.length > 0) {
      this.segments[0].focus();
    }
  }

  render() {
    const { value, options, onChange, id, className, justified, disabled } = this.props;

    const optionComponents = options.map((o, i) => (
      <Segment
        key={o.value}
        id={id}
        text={o.text}
        value={o.value}
        active={o.value === value}
        onChange={onChange}
        disabled={disabled}
        ref={seg => {
          this.segments.push(seg);
        }}
      />
    ));

    const classNames = ['pxl-segmented'];
    if (justified) {
      classNames.push('pxl-segmented--justified');
    }
    if (disabled) {
      classNames.push('pxl-segmented--disabled');
    }
    if (className) {
      classNames.push(className);
    }

    return (
      <div
        className={classNames.join(' ')}
        data-toggle="buttons"
      >
        {optionComponents}
      </div>
    );
  }
}

Segmented.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  justified: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.any
};

Segmented.defaultProps = {
  className: '',
  onChange() {},
  justified: false
};

export default Segmented;
